import React from 'react';
import { ConnectionStatusEnumType, ConnectionStatusSourceEnumType } from '@mark43/cad-api';
import type { ConnectionStatusHistoryEntry } from '@m43/bridge-interface';

export type ConnectionStatusContextValue = Record<
    ConnectionStatusSourceEnumType,
    ConnectionStatusEnumType
>;

export type ConnectionStatusContextData = {
    status: ConnectionStatusContextValue;
    history: ConnectionStatusHistoryEntry[];
};

export const defaultConnectionStatusContextValue: ConnectionStatusContextValue = {
    SOCKET: 'ONLINE',
    INTERNET: 'ONLINE',
    MARK43_PING: 'ONLINE',
    DNS_RESOLUTION: 'ONLINE',
    FARO: 'ONLINE',
};

const defaultConnectionStatusContextData: ConnectionStatusContextData = {
    status: defaultConnectionStatusContextValue,
    history: [],
};

export const ConnectionStatusContext = React.createContext<ConnectionStatusContextData>(
    defaultConnectionStatusContextData
);
